import { useQuery } from "@tanstack/react-query";
import { CONNECT_USERS_QUERY_KEY } from "../../features/Users/constants";
import { fetchConnectUsers } from "../../services/users";
import useOrgId from "../organizations/useOrgId";

export default function useConnectUsers(page = 1) {
  const orgId = useOrgId();
  return useQuery(
    [CONNECT_USERS_QUERY_KEY, orgId, page],
    () => fetchConnectUsers(page),
    {
      refetchOnWindowFocus: false,
      retry: false,
    }
  );
}
